import React, {useEffect, useState} from 'react'
import {useIntl} from 'react-intl'
import successImage from '../../../../media/EarlyAccess/early-access-img.svg'
import successImageDark from '../../../../media/EarlyAccess/early-access-img-dark.svg'
import {EarlySocialMedia} from './EarlySocialMediaSection'
import {useNavigate} from 'react-router-dom'
import {EarlyInviteCard} from './EarlyInviteCard'
import earlyAccessBanner from '../../../../media/EarlyAccess/recordskeeper-ai-early-access-landing-page-banner.png'
import {useThemeMode} from '../../../../_metronic/partials'
import earlyAccessBannerDark from '../../../../media/EarlyAccess/recordskeeper-ai-early-access-landing-page-banner-dark.png'
import {EarlyInvitees} from './EarlyInvitees'
import {useAuth} from '../../auth'
import {getInvitees} from '../core/_requests'

const EarlyAccessSuccess = () => {
  const {formatMessage} = useIntl()
  const {companyId} = useAuth()
  const [invitees, setInvitees] = useState<any[]>([])
  const navigate = useNavigate()
  const {mode} = useThemeMode()
  useEffect(() => {
    if (companyId) {
      getConfirmedInvitees()
    }
  }, [companyId]) // eslint-disable-line react-hooks/exhaustive-deps

  const getConfirmedInvitees = async () => {
    try {
      if (companyId) {
        const {
          data: {success, data},
        } = await getInvitees(companyId)
        if (success) {
          setInvitees(data)
        }
      }
    } catch (err) {
      console.log(err)
    } finally {
    }
  }
  return (
    <>
      <div className='px-6 mb-8'>
        <div className='row'>
          <div className='col-md-9 bg-white rounded-2 p-6'>
            {/* Header */}
            <div className='shadow-md'>
              {mode === 'dark' ? (
                <img
                  src={earlyAccessBannerDark}
                  alt='RecordsKeeper AI Early Access'
                  className='w-100'
                />
              ) : (
                <img
                  src={earlyAccessBanner}
                  alt='RecordsKeeper AI Early Access'
                  className='w-100'
                />
              )}
            </div>

            <div className='bg-white p-4 d-flex flex-column justify-content-center align-items-center gap-8 mt-8'>
              <h1>{formatMessage({id: 'Thank You for Your Interest!'})}</h1>
              <div className='d-flex flex-column align-items-center gap-4'>
                {mode === 'dark' ? (
                  <img src={successImageDark} alt='early-access' width={266} height={201} />
                ) : (
                  <img src={successImage} alt='early-access' width={266} height={201} />
                )}
                <h1 className='text-center'>
                  {formatMessage({id: `You're One Step Closer to An Amazing Offer`})}
                </h1>
                <div className='d-flex flex-column align-items-center'>
                  <p className='mb-0 font-size-14 text-center'>
                    {formatMessage({id: `We’ve received your request and will review it shortly.`})}
                  </p>
                  <p className='mb-0 font-size-14 text-center'>
                    {formatMessage({
                      id: `Keep an eye on your inbox for updates from RecordsKeeper.AI.`,
                    })}
                  </p>
                </div>
                <button className='btn btn-primary' onClick={() => navigate('../../dashboard')}>
                  {formatMessage({id: 'Go Back'})}
                </button>
              </div>
            </div>

            <EarlySocialMedia />
          </div>

          <div className='col-md-3'>
            <EarlyInviteCard />
            <EarlyInvitees invitees={invitees} />
          </div>
        </div>
      </div>
    </>
  )
}

export default EarlyAccessSuccess
